import React, { useMemo } from 'react';
import { BadgeCheckIcon, BuildingIcon, FileClockIcon, FlagIcon, ShieldAlertIcon, UsersIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import { ADMIN_NAVIGATION } from '../../data/adminNavigation';
import { useTerminology } from '../../hooks/useTerminology';
import { useGovernance } from '../../contexts/GovernanceContext';
const SECTION_TEMPLATES = [{
  template: '{institution:plural}',
  icon: BuildingIcon
}, {
  template: 'Accounts',
  icon: UsersIcon
}, {
  template: 'Moderation queue',
  icon: FlagIcon
}, {
  template: 'Reported accounts',
  icon: ShieldAlertIcon
}, {
  template: 'Verification queue',
  icon: BadgeCheckIcon
}, {
  template: 'Audit log',
  icon: FileClockIcon
}];
export function AdminShell() {
  const {
    phrase
  } = useTerminology();
  const {
    allows
  } = useGovernance();

  /**
   * Navigation is derived from the declared model, resolved through the
   * deployment's vocabulary and filtered by what this administrator actually
   * holds. A group with nothing left in it is dropped rather than left as an
   * empty heading.
   *
   * Hiding is presentation only — the services still refuse the action, so a
   * remembered URL gains nobody anything.
   */
  const groups = useMemo(() => ADMIN_NAVIGATION.map(group => ({
    label: phrase(group.labelTemplate),
    items: group.items.filter(item => !item.permission || allows(item.permission as never).allowed).map(item => ({
      to: item.to,
      label: phrase(item.labelTemplate),
      icon: item.icon,
      end: item.end
    }))
  })).filter(group => group.items.length > 0), [allows, phrase]);
  return <OperatorShell consoleKey="admin" consoleName={phrase('{platform} admin')} scopeLine="Platform operations · Nigeria region" groups={groups} summary={<div data-id="element-4484" data-mp="3thmlxcf4o55e">
          <p className="text-body-sm leading-6 text-ink-muted" data-id="element-4485" data-mp="3ti4pku44dlnc">
            Moderation, verification and sensitive-data access are separated by design. Every action
            below is attributed and logged.
          </p>
          <ul className="mt-4 space-y-1.5 border-t border-line pt-3" data-id="element-4486" data-mp="1u9mocmwj4elh">
            {SECTION_TEMPLATES.map(section => {
        const Icon = section.icon;
        const label = phrase(section.template);
        return <li key={label} className="flex items-center gap-2 text-caption text-ink-muted" data-id="element-4487" data-mp="2i1tolx5dl5q6">
                  <Icon aria-hidden className="h-3.5 w-3.5 shrink-0 text-ink-subtle" data-id="element-4488" data-mp="2dz6vlswyxere" />
                  {label}
                </li>;
      })}
          </ul>
        </div>} data-id="element-4483" data-mp="6erm6px4tsx3" />;
}